/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromAggregate from 'Simple/Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import DownloadAction from './DownloadAction/index'
import Lock from './Lock/index'
import PrintAction from './PrintAction/index'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Financial/Content/Statements/Data/Content/Actions/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
let constantData = 'Statements:'
let tabSelectedStatementsSelectedRowsLengthValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'selected.statements.selected_rows.length',
})
let aggregateData = fromAggregate.join(constantData, tabSelectedStatementsSelectedRowsLengthValueData)
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--b-1-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-2-Z1Yf8zk': dtColorsNeutral500,'--bc-3-Z1Yf8zk': dtColorsWhite,'--btlr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-3-Z1Yf8zk': dtColorsNeutral200,'--bbc-8-Z1Yf8zk': dtColorsNeutral400,'--pb-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pt-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-12-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h3"
 data="'Statements:'"
 data="tab.selected.statements.selected_rows.length"
 aggregate="/Simple/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pt-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-12-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Vertical1}`}
>
<DownloadAction
  viewPath={`${viewPath}/DownloadAction`}
/>
<PrintAction
  viewPath={`${viewPath}/PrintAction`}
/>
</div>
</div>
<Lock
  viewPath={`${viewPath}/Lock`}
/>
{children}
</React.Fragment>)
}